export default __webpack_public_path__ + "static/media/pricing-green.93ff6ad7.webp";